const GET_TABEL_SAFE = "GET_TABEL_SAFE";
const GET_TABEL_SAFE_SUCCESS = "GET_TABEL_SAFE_SUCCESS";
const GET_TABEL_SAFE_FAIL = "GET_TABEL_SAFE_FAIL";

export {
    GET_TABEL_SAFE,
    GET_TABEL_SAFE_SUCCESS,
    GET_TABEL_SAFE_FAIL,
};